module.exports = __webpack_public_path__ + "img/las-canadas__logo.82272b49.svg";